import React from "react";
import { useDispatch, useSelector } from "react-redux";

import PartNumber from "pu-react/components/PartNumber";
import Revision from "pu-react/components/Revision";
import GerberFile from "us_pcb_assembly/project/ZipFile";

import {
  changeParameter,
  projectValidator as validator,
} from "shared/product_tabs/tab_assembly/assemblySlice";
import { selectAssemblyParameters } from "product_tabs/tab_assembly/selector/selector";
import { changeGlobalParameter } from "product_tabs/actions";

const Project = () => {
  const dispatch = useDispatch();
  const { parameters, validatorFlag } = useSelector(selectAssemblyParameters);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
    dispatch(changeGlobalParameter({ name, value }));
  };
  const props = {
    parameters,
    onChangeParameter,
  };

  return (
    <div className="project-information row">
      <div className="col-lg-2">
        <PartNumber
          {...props}
          errorMessage={validator.message(
            "Part Number",
            parameters.part_number,
            "required|min:3"
          )}
        />
      </div>
      <div className="col-lg-2">
        <Revision
          {...props}
          errorMessage={validator.message(
            "Revision",
            parameters.revision,
            "required"
          )}
        />
      </div>
      <div className="col-lg-2">
        <GerberFile
          {...props}
          label="Upload Zip File"
          text="Browse"
          validator={validator}
        />
      </div>
    </div>
  );
};

export default Project;
